import React from "react";
import ChatView from "../../components/views/chat-view/ChatView";

export default function ChatPage() {
  return <ChatView />;
}
